import { combineReducers } from 'redux';
import { authReducer } from '../app/modules/auth/core/reducer';
import { addressesReducer } from '../app/modules/addresses/core/reducer';
import { customerReducer } from '../app/modules/customer/core/reducer';
import { ordersReducer } from '../app/modules/orders/core/reducer';
import { orderScheduleReducer } from '../app/modules/order-schedule/core/reducer';
import { paymentMethodsReducer } from '../app/modules/payment/core/reducer';
import { productsReducer } from '../app/modules/products/core/reducers';
import { subscriptionsReducer } from '../app/modules/subscriptions/core/reducers';
import { settingsReducer } from '../app/modules/settings/core/reducers';
import { productUpdatedReducer } from '../app/modules/product-updated/core/reducer';
import { shopReducer } from '../app/modules/shop/core/reducer';
import { AuthAction } from '@modules/auth/core/actionTypes';

const appReducer = combineReducers({
  auth: authReducer,
  addresses: addressesReducer,
  customer: customerReducer,
  orders: ordersReducer,
  orderSchedule: orderScheduleReducer,
  paymentMethods: paymentMethodsReducer,
  products: productsReducer,
  subscriptions: subscriptionsReducer,
  settings: settingsReducer,
  recalculatedProduct: productUpdatedReducer,
  shop: shopReducer,
});

export type RootState = ReturnType<typeof appReducer>;

export const rootReducer = (state: RootState | undefined, action: { type: string }) => {
  if (action.type === AuthAction.LOGOUT_SUCCESS) {
    state = undefined;
  }

  return appReducer(state, action as any);
};
